<template>
  <div>
    <table style="width: 100%">
      <td style="width: 10%" @click="hideRaffle"></td>
      <td class="ticket-raffle-table" style="width: 80%;" @click="showRaffle()">
        <table align=center>
          <tr>
            <td :class="'stat-bar-'+ticketRaffleStatus">
            </td>
            <td>
              <table>
                <tr>
                  <td class="ticket-raffle-keyword" colspan="2">{{ticketRaffle.keyword}}</td>
                </tr>
                <tr>
                  <td class="ticket-raffle-info">Status: {{ticketRaffleStatus}}</td>
                  <td class="ticket-raffle-info" style="text-align: center;">Your Tickets: {{formatCurrency(myTickets)}}</td>
                </tr>
                <tr>
                  <td class="ticket-raffle-info">Price per ticket: {{formatCurrency(ticketRaffle.price)}}</td>
                  <td class="ticket-raffle-info" style="text-align: center;">Total Entries: {{formatCurrency(ticketRaffle.total_entries)}}</td>
                </tr>
              </table>
            </td>
            <td :class="'stat-bar-'+ticketRaffleStatus">
            </td>
          </tr>
        </table>
        <div class="ticket-raffle-expand" v-if="showPlaced" >
          <br/>
          <a>{{ticketRaffle.title}}</a>
          <br/>
          <br/>
          <buyTicket v-if="$store.state.currentUser&&ticketRaffleStatus=='Open'" v-bind:price="ticketRaffle.price" v-on:callBuyTicket="callBuyTicket" v-bind:myTickets="formatCurrency(myTickets)"></buyTicket>
          <login-btn v-if="!$store.state.currentUser&&ticketRaffleStatus=='Open'" style="display: inline-block;">Login to buy tickets</login-btn>
          <transition name="slide-fade">
            <div>
              <br />
              <div style="font-weight:bold;">Entries</div>
              <ticket-raffle-entries v-if="showPlaced" :ticketRaffleId="ticketRaffleId" :ticketRaffle="ticketRaffle"></ticket-raffle-entries>
            </div>
          </transition>
        </div>
      </td>
      <td style="width: 10%" @click="hideRaffle"></td>
    </table>
    <br/>
  </div>
</template>

<script>
import buyTicket from './Buy-Ticket'
export default {
  name: 'ticket-raffle',
  props: ['ticketRaffleId'],
  async created () {
    this.$store.dispatch('fetchTicketRaffle', this.ticketRaffleId)
  },
  components: {
    buyTicket
  },
  data () {
    return {
      showPlaced: false
    }
  },
  computed: {
    myTickets () {
      return this.$store.state.myTickets[this.ticketRaffleId] ? this.$store.state.myTickets[this.ticketRaffleId].quantity : 0
    },
    ticketRaffle () {
      console.log(this.$store.state.ticketRaffles[this.ticketRaffleId])
      return this.$store.state.ticketRaffles[this.ticketRaffleId]
    },
    ticketRaffleStatus () {
      /*
        "created": 1,
        "completed": 2,
        "pending': 3,
        'canceled': 4
      */
      if (this.ticketRaffle.status === 2) {
        return 'Completed'
      } else if (this.ticketRaffle.status === 4) {
        return 'Canceled'
      } else if (this.ticketRaffle.status === 5) {
        return 'Closed'
      } else {
        return 'Open'
      }
    }
  },
  methods: {
    showRaffle: function () {
      if (!this.placedFetched && !this.showPlaced) {
        this.$store.dispatch('fetchTicketRaffle', this.ticketRaffleId)
        this.showPlaced = true
      }
    },
    hideRaffle () {
      this.showPlaced = false
    },
    callBuyTicket (amount) {
      const raffleIdx = this.ticketRaffleId
      this.$store.dispatch('buyTicket', {raffleIdx, amount})
    },
    collapseSection (element) {
      element.style.maxHeight = 0 + 'px'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-in;
}
.slide-fade-leave-active {
  transition: all 0.3s ease-in-out;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.center {
  display: table;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  transition: border 0.5s ease;
  border: 3px #b6262600 solid;
}

.center:hover {
  border: 3px #b62626 solid;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.shadow-z-1 {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12),
    0 1px 2px 0 rgba(0, 0, 0, 0.24);
  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12),
    0 1px 2px 0 rgba(0, 0, 0, 0.24);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 1px 2px 0 rgba(0, 0, 0, 0.24);
}
  .ticket-raffle-table{
    width: 100%;
    border-collapse: collapse;
    background-color: rgba(0, 0, 0, 0.2);
    outline: 3px rgba(255, 0, 0, 0) solid;
    transition: outline 0.3s;
  }
  .ticket-raffle-table:hover{
    outline: 3px #b62626 solid;
  }
  .stat-bar-Open{
    width: 1%;
    height: 100%;
    background-color: rgb(88, 255, 88);
    box-shadow: 0px 0px 8px rgb(57, 199, 0);
  }
  .stat-bar-Completed{
    width: 1%;
    height: 100%;
    background-color: rgb(54, 135, 228);
  }
  .ticket-raffle-keyword{
    font-size: 34px;
    font-weight: bold;
    padding: 5px;
    border: 1px rgba(255, 255, 255, 0.15) solid;
    background-color: rgba(0, 0, 0, 0.2);
  }
  .ticket-raffle-info{
    text-align: left;
    font-size: 20px;
    padding: 5px;
  }
  .ticket-raffle-expand{
    width: 100%;
    overflow: hidden;
  }
  .ticket-raffle-expand a{
    margin: 20px;
    color: rgb(218, 218, 218);
    font-size: 18px;
  }
  .ticket-raffle-expand-button{
    width: 60%;
    font-size: 30px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Ticket-Raffle.vue